function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.5 86H58C74.0484 75.4063 83.228 68.6635 98.5 61.5C103.814 56.2152 106.915 53.2753 112.5 53C117.171 53.1049 119.72 54.7494 124 60.5C118.132 62.7423 114.881 64.0388 113 70.5C110.998 77.584 109.139 80.6731 104 84C94.1667 89.1499 87.5057 92.1712 89 96C90.4067 100.598 93.2011 102.966 100 107C95.8966 106.053 93.4859 106.082 89 107L91 105C89.9896 103.355 88.5512 102.047 85.5 99.5C84.2803 98.1007 83.723 97.1224 83 95H77L80.5 93C71.686 92.8609 62.8578 95.2654 42.5 102.5C42.7045 101.692 42.3758 101.702 41 102.5C39.3154 102.501 38.2647 102.502 36 102.5C37.3255 101.358 38.2328 100.697 40 99.5H37.5C46.3281 94.7199 51.9211 91.8016 63.5 86Z",
  fill: "white"
});

function SvgCoinIconKsm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconKsm);
export default __webpack_public_path__ + "static/media/CoinIconKSM.fcad2866.svg";
export { ForwardRef as ReactComponent };